import { get, post, put } from "../index";
import AdGuruRoutes from "./AdGuru.Routes";

const AdGuruServices = {
  getAdGuru: async (catId, search, page, limit, type) => {
    let params = `?page=${page}&limit=${limit}&type=${type}`;
    if (catId) params += `&category=${catId}`
    if (search) params += `&title=${search}`
    const result = await get(AdGuruRoutes.getAllAdbooks + params
    );
    return result;
  },
  createAdGuru: async (obj) => {
    const result = await post(AdGuruRoutes.createAdbook, obj);
    return result;
  },

  updateAdGuru: async (id, obj) => {
    const result = await put(AdGuruRoutes.updateAdbook + `/${id}`, obj);
    return result;
  }
}

export default AdGuruServices;